import { Vue } from "vue-property-decorator";
import vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import * as vuexClass from "vuex-class";
import * as vuePropertyDecorator from "vue-property-decorator";
import * as vueClassComponent from "vue-class-component";
import * as axiosInstance from "@/axios.instance";
import * as V2Mapping from "@sureview/v2-mapping";
import * as vueShortkey from "vue-shortkey";
import * as vueSimplePortal from "@linusborg/vue-simple-portal";
import * as lodash from "lodash";
import * as V2Cameras from "@sureview/v2-cameras";
import * as v2Dropdown from "@sureview/vuejs-sv-dropdown";
import * as InsightsGraph from "@/components/reports/InsightsGraph.vue";
import vSelect from "vue-select";
import TextHighlight from "vue-text-highlight";
import AreaDetails from "@/components/AreaDetails.vue";
import AreaSelect from "@/components/form/AreaSelect.vue";
/* AreaTreeSelect is a new improved tree structure. Change to this from AreaSelect
   Link: https://dev.azure.com/sureviewcc/CC/_wiki/wikis/ImmixCC.wiki/775/Area-Tree-Select
*/
import AreaTreeSelect from "@/components/form/AreaTreeSelect.vue";
import AreaSchedule from "@/components/areas/AreaSchedule.vue";
import GroupIsArmedModal from "@/components/arm-disarm/GroupIsArmedModal.vue";
import GroupIsDisarmedModal from "@/components/arm-disarm/GroupIsDisarmedModal.vue";
import GroupIsOnTestModal from "@/components/arm-disarm/GroupIsOnTestModal.vue";
import EventQueue from "@/views/EventQueue.vue";
import QuickControl from "@/views/QuickControl.vue";
import Intercom from "@/components/event-queue/Intercom.vue";
import IntercomModal from "@/components/event-queue/IntercomModal.vue";
import IntercomAudioReceive from "@/components/event-queue/IntercomAudioReceive.vue";
import IntercomAudioTransmit from "@/components/event-queue/IntercomAudioTransmit.vue";
import SureViewIcon from "@/components/SureViewIcon.vue";
import ExternalMapLayerPropertiesSetup from "@/components/ExternalMapLayerPropertiesSetup.vue";
import RegionSelect from "@/components/form/RegionSelect.vue";
import * as RegionUtils from "@/utils/region-utils";
import vSelect3 from "vselect3";

window["vue"] = Vue;
window["vuex"] = vuex;
window["vuex-class"] = vuexClass;
window["vue-property-decorator"] = vuePropertyDecorator;
window["vue-class-component"] = vueClassComponent;
window["bootstrap-vue"] = BootstrapVue;
window["axios.instance"] = axiosInstance;
window["@sureview/v2-mapping"] = V2Mapping;
window["vue-shortkey"] = vueShortkey;
window["@linusborg/vue-simple-portal"] = vueSimplePortal;
window["lodash"] = lodash;
window["@sureview/v2-cameras"] = V2Cameras;
window["@sureview/vuejs-sv-dropdown"] = v2Dropdown;

window["insights"] = InsightsGraph;
window["vue-select"] = vSelect;
window["vselect3"] = vSelect3;
window["vue-text-highlight"] = TextHighlight;
window["sureview-icon"] = SureViewIcon;

/*
!!!IMPORTANT!!!
When multiple exposing components of a similar name, use the following format
MainComponentName/SubComponent

There is a weird bug where if you provided the following:
window["alarm-queue-table"] = AlarmQueue;
window["alarm-queue-header"] = AlarmQueueHeader;

Only the first would get loaded
*/

window["event-queue"] = EventQueue;
window["quick-control"] = QuickControl;
window["area-details-component"] = AreaDetails;
window["area-schedule"] = AreaSchedule;
window["area-select"] = AreaSelect;
/* AreaTreeSelect is a new improved tree structure. Change to this from AreaSelect
   Link: https://dev.azure.com/sureviewcc/CC/_wiki/wikis/ImmixCC.wiki/775/Area-Tree-Select
*/
window["area-tree-select"] = AreaTreeSelect;
window["group-is-armed-modal"] = GroupIsArmedModal;
window["group-is-disarmed-modal"] = GroupIsDisarmedModal;
window["group-is-on-test-modal"] = GroupIsOnTestModal;

window["external-map-layer-properties"] = ExternalMapLayerPropertiesSetup;

window["intercom"] = Intercom;
window["intercom-modal"] = IntercomModal;
window["intercom-audio-receive"] = IntercomAudioReceive;
window["intercom-audio-transmit"] = IntercomAudioTransmit;
window["region-select"] = RegionSelect;
window["region-utils"] = RegionUtils;
